import { DASHBOARD_GET_DATA } from "../../Constants/DashboardConstants"

const initialState = {
    loading: false,
    status: false,
    data: null,
    error: null,
    errors: null,
};

// Common Reducer
export const createGetDataReducer = (req: any) => (state = initialState, action: any) => {

    switch (action.type) {
        case `${req}_RESET`:
            return {
                ...initialState,
            };
        case `${req}_REQUEST`:
            return {
                ...state,
                loading: true,
            };
        case `${req}_SUCCESS`:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload,
            };
        case `${req}_FAIL`:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const DashboardDataGetReducer = createGetDataReducer(DASHBOARD_GET_DATA);
export const DashboardRedirectionReducer = createGetDataReducer('DASHBOARD_REDIRECTION');
